import React, { useState } from "react";
import PropTypes from "prop-types";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import TransitionConfirmAction from "MODULES/shared/components/TransitionConfirmAction/TransitionConfirmAction";
import { CANCELLATION_REASONS } from "MODULES/PurchaseOrders/constants";
import CancelSendPOModal from "./CancelSendPOModal";

export default function CancelSendPo({
  cancelled,
  cancelPurchaseOrder,
  purchaseOrder
}) {
  const {
    sendModalOpen,
    confirmActionProps,
    handleSendModalClose
  } = useCancelSendPo({
    cancelled,
    cancelPurchaseOrder
  });

  return (
    <React.Fragment>
      <DropDownItem onClick={confirmActionProps.openModal}>
        <span className="text-danger">
          <i className="fa fa-fw fa-ban" />{" "}
          {cancelled ? (
            <span>Reverse Cancellation</span>
          ) : (
            <span>Cancel PO</span>
          )}
        </span>
      </DropDownItem>

      {sendModalOpen ? (
        <CancelSendPOModal
          purchaseOrder={purchaseOrder}
          visible={sendModalOpen}
          close={handleSendModalClose}
        />
      ) : (
        <TransitionConfirmAction {...confirmActionProps}>
          <strong>Heads Up!</strong>
          &nbsp;
          {cancelled
            ? "Are you sure you want to reverse this cancelled order?"
            : "Cancelling a PO will cancel all line items associated with it."}
          {!cancelled && (
            <div>
              <label className="control-label" htmlFor="cancellation_reason">
                Cancellation Reason
              </label>
              <select
                className="form-control"
                name="cancellation_reason"
                onChange={confirmActionProps.handleSelectChange}
                value={confirmActionProps.cancellationReason}
              >
                {CANCELLATION_REASONS.map(reason => (
                  <option key={reason.value} value={reason.value}>
                    {reason.text}
                  </option>
                ))}
              </select>
            </div>
          )}
          {!cancelled && (
            <div
              className="form-check mt-3"
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "15px"
              }}
            >
              <input
                type="checkbox"
                className="form-check-input"
                id="sendCancellationPO"
                checked={confirmActionProps.sendCancellationPO}
                onChange={confirmActionProps.handleCheckboxChange}
                style={{ marginRight: "10px" }}
              />
              <label
                className="form-check-label"
                htmlFor="sendCancellationPO"
                style={{ margin: 0, marginTop: "4px" }}
              >
                Send Cancellation PO
              </label>
            </div>
          )}
        </TransitionConfirmAction>
      )}
    </React.Fragment>
  );
}

function useCancelSendPo({ cancelled, cancelPurchaseOrder }) {
  const [cancelPoModalOpen, setCancelPoModalOpen] = useState(false);
  const [cancellationReason, setCancellationReason] = useState(
    CANCELLATION_REASONS[0].value
  );
  const [sendModalOpen, setSendModalOpen] = useState(false);
  const [sendCancellationPO, setSendCancellationPO] = useState(false);

  const handleSelectChange = e => setCancellationReason(e.target.value);

  const handleCheckboxChange = e => setSendCancellationPO(e.target.checked);

  const handleCancelPurchaseOrder = () =>
    cancelPurchaseOrder(cancellationReason).then(() => {
      setCancelPoModalOpen(false);
      if (!cancelled && sendCancellationPO) {
        setSendModalOpen(true);
      }
    });

  const openModal = () => setCancelPoModalOpen(true);
  const closeModal = () => setCancelPoModalOpen(false);
  const handleSendModalClose = () => setSendModalOpen(false);

  return {
    sendModalOpen,
    handleSendModalClose,
    confirmActionProps: {
      open: cancelPoModalOpen,
      close: closeModal,
      onConfirm: handleCancelPurchaseOrder,
      openModal,
      closeModal,
      cancellationReason,
      sendCancellationPO,
      handleSelectChange,
      handleCheckboxChange,
      btnClass: cancelled ? "btn-primary" : "btn-danger",
      btnText: cancelled ? "Reverse Cancellation" : "Yes, Cancel PO",
      cancelText: cancelled ? "Cancel" : "Do not Cancel PO",
      icon: cancelled ? (
        <i className="fa fa-fw fa-refresh" />
      ) : (
        <i className="fa fa-fw fa-ban" />
      )
    }
  };
}

CancelSendPo.propTypes = {
  cancelled: PropTypes.bool.isRequired,
  cancelPurchaseOrder: PropTypes.func.isRequired,
  purchaseOrder: PropTypes.instanceOf(Map).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/CancelSendPo/CancelSendPo.jsx